import { render, staticRenderFns } from "./OrderHeadersDialog.vue?vue&type=template&id=26402adf&scoped=true"
import script from "./OrderHeadersDialog.vue?vue&type=script&lang=js"
export * from "./OrderHeadersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26402adf",
  null
  
)

export default component.exports